import axiosNextGen from '../../../config/axios-nextgen';

/**
 * Exam API Service (Next-Gen)
 */

/**
 * Update the same-day provider visit flag on an exam
 * @param {string} patientExamId
 * @param {boolean} sameDayProviderVisitYn
 * @returns {Promise<void>}
 */
export async function updateSameDayProviderVisit(patientExamId, sameDayProviderVisitYn) {
    await axiosNextGen.patch('/api/exams/same-day-provider-visit', {
        patientExamId,
        sameDayProviderVisitYn
    });
}

/**
 * Write a result's notes and nothing else.
 *
 * Not the same as a full result update: that path also marks the exam performed and upserts the
 * patient recall, which must not happen just because the notes box was flushed. The server skips
 * the write when the text is unchanged.
 *
 * @param {string} resultId
 * @param {string|null} notes
 * @returns {Promise<void>}
 */
export async function updateResultNotes(resultId, notes) {
    await axiosNextGen.put(`/api/exams/results/${resultId}/notes`, { notes });
}
